import request from '@/util/request';

export async function loadAll() {
  return await request.get('/api/getVendors');
}
